import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import store from 'web-app/react/redux/store';
import {configureSentryScope} from 'web-app/shared/sentry-setup';
import {fetchAccountCompleted} from 'web-app/react/session/actions';
import generateUUID from 'web-app/util/uuid';
import LocalStorageService from 'web-app/services/local-storage';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import {setLoginIdForLocalStorage, setSecretForLocalStorage} from 'web-app/services/local-storage';

export const updateAccount = (
    firstName: string,
    middleName: string,
    lastName: string,
    street: string,
    zip: string,
    city: string,
    phone: string,
    homePhone: string,
    workPhone: string,
    locale: string,
    timeZone?: string,
) => {
    return RESTClient.postAuthenticatedObservable('me/me/updatelogin', {
        firstName,
        middleName,
        lastName,
        street,
        zip,
        city,
        phone,
        homePhone,
        workPhone,
        locale,
        timeZone,
    });
};

export const fetchAccount = () => {
    // uuid is set to make sure that enterprise caches don't serve the content of other users
    const data = {
        uuid: generateUUID(),
        deviceId: LocalStorageService.getFromLocalStorage('deviceId'),
        intercomPlatform: 'html',
    };

    return RESTClient.getAuthenticated('me/me/me', data).then(response => {
        /**
         * Offline observations are encrypted with a secret from /me/me/me.
         * We have to wait for account to be fetched before we can read it.
         *
         * This was copied from the Ember route in `app/routes/account.js`.
         * I left it in there as I don't dare touch that code as a part of this PR.
         * Some features, e.g. Offline observation drafts, needs access to local storage
         * and these keys needs to be set before the ObservationEditor is able to mount.
         */
        setLoginIdForLocalStorage(response.loginId);
        setSecretForLocalStorage(response.localSecret);

        store.dispatch(fetchAccountCompleted(response));

        configureSentryScope(scope => {
            scope.setUser({
                id: response.loginId,
            });
        });

        return {
            ...response,
            behaviors: new BehaviorsCollection(response.behaviors),
        };
    });
};
